type channels = { hotel: boolean; package: boolean };

export enum WhitelabelNames {
  holidaypirates = "holidaypirates",
  holidaypiratesAustrian = "holidaypiratesaustrian",
  booking = "booking",
  lastminute = "lastminute",
  wegde = "wegde",
  affiliation = "affiliation",
  travelzoo = "travelzoo",
  partnership = "partnership",
}

export enum VoucherPortal {
  wegde = "wegde",
  lastminute = "lastminute",
  holidaypirates = "urlaubspiratenwegde",
  booking = "booking_dot_com",
}

export enum WhitelabelThemeNames {
  skeletor = "Skeletor",
  vaultBoy = "VaultBoy",
  pinkPanther = "PinkPanther",
  garfield = "Garfield",
}

export type homePageBreadcrumbsData = Array<{ label: string; url?: string }>;

export type WhitelabelConfig = {
  name: WhitelabelNames;
  themeName: WhitelabelThemeNames;
  brand: string;
  privacyTermsUrl: string;
  privacyTermsEmail: string;
  website: string;
  rootPath: string;
  thankYouPageRedirection: string;
  oseTrackingIdBrand: string;
  hotelListDefaultSort: string;
  destinationListDefaultSort: string;
  hotelDetailDefaultSort: string;
  bookingForm?: {
    loggedInText: string;
  };
  trackway?: {
    startrackAppName: string;
    arpAppName: string;
    brand: string;
  };
  customerService: {
    serviceEmail: string;
    servicePhoneHumanReadable: string;
    servicePhoneMachineReadable: string;
    openingTime: string;
    offDaysTime?: string;
  };
  hasFlexibleCancellation: {
    hotelList: boolean;
    hotelDetail: boolean;
    dlp: boolean;
  };
  allowMetaTags: boolean;
  hasWegDeVoucher: boolean;
  hasVoucherRedemptionOnCheckoutPage: boolean;
  hasKoreChat: boolean;
  quickVacancyPreFetchOffersCount: number;
  twitter: string;
  hasChannels: channels;
  viewMode: {
    mandator: number;
    profile: {
      package: number;
      hotel?: number;
    };
  };
  cookieConsentManager?: {
    theme: string;
    brand: string;
    country: string;
  };
  hasStartPage?: boolean;
  hasFavorites: boolean;
  campaign: {
    pages: {
      reiseziele: {
        visible: boolean;
        bannerRedirectUrl?: string;
      };
      liste: {
        visible: boolean;
        bannerRedirectUrl?: string;
      };
      hotel: {
        visible: boolean;
        bannerRedirectUrl?: string;
      };
      buchung: {
        visible: boolean;
        bannerRedirectUrl?: string;
      };
      bestaetigung: {
        visible: boolean;
        bannerRedirectUrl?: string;
      };
    };
    limitedTime?: {
      startDate: Date;
      endDate: Date;
    };
  };
  tiefpreisgarantie: string;
  hasUserAccountLink: boolean;
  userAccountLink: string;
  hasTrustedShops: boolean;
  travelAudienceAccountId?: string;
  hasGoogleAdsense?: boolean;
  hasBannerGPT?: boolean;
  voucher: {
    link: string;
    conditionsLink: string;
    portal: VoucherPortal; // for API
  };
  dataLayerTrackingId?: string;
  platformDataTracking: {
    startPageId?: string;
    brand: string;
    locale: string;
    id: string;
    whitelabelName?: string;
  };
  tealiumUrl?: {
    prod: string;
    qa: string;
  };
  userAreaLink?: string;
  reviews: {
    brand: string;
    portals: string[];
  };
  legalLinks: {
    comvel: {
      url: string;
      urlDesktop?: string;
    };
    termsAndConditions: {
      url: string;
      urlDesktop?: string;
      urlConsent?: string;
    };
    voucher: {
      url: string;
      text: string;
    };
    tourOperator: {
      url: string;
    };
    entryRequirements: {
      url: string;
      text: string;
    };
    relevanceSortOrder: {
      url: string;
    };
  };
  seoContent?: {
    homePageTitle?: string;
    homePageDescription?: string;
    destinationStartPage?: string;
    destinaionHotelList?: string;
    hotelDetails?: string;
    dlps?: string;
    hlps?: string;
  };
  marketingConsent: {
    brand: string;
    country: string;
    additionalParams?: [string, string][];
  };
  searchbarZIndex?: {
    regular: number;
    sticky: number;
  };
  insurance: {
    hmrvButtonLink: string;
  };
  header?: {
    brand: string;
    name: string;
    whitelabel?: string;
  };
  footer?: {
    brand: string;
    name: string;
    whitelabel?: string;
  };
  headerContentUrl?: {
    funnel?: {
      production: string;
      staging: string;
    };
    landing?: {
      production: string;
      staging: string;
    };
  };
  chatbotHostLink?: string;
  footerContentUrl?: {
    staging: string;
    production: string;
  };
  mapboxApiKeyName: string;
  mapboxApiKeyNameDetailPage: string;
  supportBannerNumber?: string;
  supportBannerTimeSchedulePrefix?: string;
  supportBannerInactivityHeader?: string;
  supportBannerInactivityCopy?: string;
  supportBannerInactivityTimeSchedule?: string;
  supportBannerInactivityTimeSchedule2?: string;

  supportBannerCheckoutHeader?: string;
  supportBannerCheckoutCopy?: string;
  supportBannerCheckoutTimeSchedule?: string;
  supportBannerCheckoutTimeSchedule2?: string;

  supportBannerNoResultHeader?: string;
  supportBannerNoResultCopy?: string;
  supportBannerNoResultTimeSchedule?: string;
  supportBannerNoResultTimeSchedule2?: string;

  homePageBreadcrumbs: homePageBreadcrumbsData;
};
